import { RadioactiveCircleOutlineIcon } from './RadioactiveCircleOutlineIcon';

/**
 * author: Michael Miday
 * id 1C482356-F93E-46FB-B4FF-6142BB859A7F
 * name radioactive-circle-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radioactive-circle-outline.svg
 * tags
 * - Science 
 */
export const RadiationCircleOutlineIcon = RadioactiveCircleOutlineIcon;
export default RadiationCircleOutlineIcon